import React, { Component, Suspense } from 'react'
import { HashRouter, Route, Routes } from 'react-router-dom'
import { ToastContainer } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import './scss/style.scss'
import PrivateRoute from 'src/helpers/PrivateRoute'
import DefaultLayout from './layout/DefaultLayout'
import ReportLayout from './layout/ReportLayout'

const loading = (
  <div className="pt-3 text-center">
    <div className="sk-spinner sk-spinner-pulse" color='var(--primary)'></div>
  </div>
)

class App extends Component {
  render() {
    return (
      <HashRouter>
        <Suspense fallback={loading}>
          <Routes>
            <Route path="/dashboard/:id" element={<PrivateRoute><ReportLayout /></PrivateRoute>} />
            <Route path="*" element={<PrivateRoute><DefaultLayout /></PrivateRoute>} />
          </Routes>
        </Suspense>
        <ToastContainer
          position="top-right"
          autoClose={5000}
          hideProgressBar={false}
          newestOnTop
          closeOnClick
          pauseOnHover
          draggable
          theme="colored"
          style={{ zIndex: 2147483647 }}
        />
      </HashRouter>
    )
  }
}

export default App
